/**
 * @generated SignedSource<<c5316fc881b0346e6e693a4db496d53e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LikeEpisodeInput = {
  episodeId: string;
  topicSlug: string;
};
export type DashboardHomeLikeMutation$variables = {
  input: LikeEpisodeInput;
};
export type DashboardHomeLikeMutation$data = {
  readonly likeEpisode: {
    readonly episode: {
      readonly id: string;
      readonly isLikedByViewer: boolean | null | undefined;
      readonly likeCount: number;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly field: string | null | undefined;
      readonly message: string;
    }>;
  };
};
export type DashboardHomeLikeMutation = {
  response: DashboardHomeLikeMutation$data;
  variables: DashboardHomeLikeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LikeEpisodePayload",
    "kind": "LinkedField",
    "name": "likeEpisode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Episode",
        "kind": "LinkedField",
        "name": "episode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isLikedByViewer",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "likeCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardHomeLikeMutation",
    "selections": (v1/*: any*/),
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardHomeLikeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "839729d66c1f2cc4b3282160c7f86cdc",
    "id": null,
    "metadata": {},
    "name": "DashboardHomeLikeMutation",
    "operationKind": "mutation",
    "text": "mutation DashboardHomeLikeMutation(\n  $input: LikeEpisodeInput!\n) {\n  likeEpisode(input: $input) {\n    episode {\n      id\n      isLikedByViewer\n      likeCount\n    }\n    userErrors {\n      message\n      field\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ea108ac4fb5569d6d6a3f692a5a19e2c";

export default node;
